import { render, staticRenderFns } from "./BankListPop.vue?vue&type=template&id=57cb97d2&"
import script from "./BankListPop.vue?vue&type=script&lang=js&"
export * from "./BankListPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports